import React, { useMemo } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries';
import type { BoardToolWebItem, SprintActionsLocation } from '../../common/types';
import { BoardToolSubItem } from '../../common/ui/tool-sections/board-tool-section-view/board-tool-sub-item';
import { useFetchedSprintActions } from '../../controllers';

export type SprintActionsConnectProps = {
	sprintId: string;
	location: SprintActionsLocation;
};

const SprintActionsConnectInner = ({ sprintId, location }: SprintActionsConnectProps) => {
	const sprintActions = useFetchedSprintActions({ sprintId });
	const targetActions: BoardToolWebItem[] | null = useMemo(
		() => sprintActions?.[sprintId]?.[location] ?? null,
		[sprintId, location, sprintActions],
	);

	if (!sprintActions || !targetActions) {
		return null;
	}

	return (
		<>
			{targetActions.map((item) => (
				<BoardToolSubItem key={item.id} subItem={item} />
			))}
		</>
	);
};

export function SprintActionsConnectMenuItems(props: SprintActionsConnectProps) {
	return (
		<JSErrorBoundary
			id="board-connect-toolbar"
			packageName="@atlassian/jira-software-sprint-actions-connect-items"
			teamName="a4t-tanuki"
			fallback="flag"
		>
			<SprintActionsConnectInner {...props} />
		</JSErrorBoundary>
	);
}
